import React from 'react';
import ptcImage from '../../imagenes/ptc.jpg';

const Navigation = ({ onToggleMenu, selectedMenu }) => {
    const renderMenuItems = (items) => {
        return items.map((item, index) => {
            if (item.subItems) {
                return (
                    <li key={index} className="nav-item dropdown">
                        <a
                            className="nav-link dropdown-toggle"
                            href="#"
                            id={`navbarDropdown${index}`}
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            {item.label}
                        </a>
                        <ul className="dropdown-menu" aria-labelledby={`navbarDropdown${index}`}>
                            {item.subItems.map((subItem, subIndex) => (
                                <li key={subIndex}>
                                    <a className="dropdown-item" href={subItem.href}>
                                        {subItem.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </li>
                );
            }
            return (
                <li key={index} className="nav-item">
                    <a className="nav-link" href={item.href}>{item.label}</a>
                </li>
            );
        });
    };

    return (
        <div style={{height:10, backgroundColor:'#086B56'}}>
        </div>
    );
};

export default Navigation;
